<div
  class="modal fade teste modal-warning"
  [attr.id]="customId"
  tabindex="-1"
  role="dialog"
  [attr.aria-labelledby]="customIdLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="warning-modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="customIdLabel">{{ title }}</h5>
      </div>
      <div class="modal-body" [ngClass]="{ 'modal-body--pt22': !question }">
        <em class="material-icons icon-warning">warning</em>
        <p>{{ warning }}</p>
        <p class="font-weight-bold" *ngIf="question" style="margin: 20px 0">
          {{ question }}
        </p>
      </div>
      <div
        class="modal-footer"
        [ngClass]="{ 'modal-footer--center': singleButton }"
      >
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          (click)="onCancelButton()"
          *ngIf="!singleButton"
        >
          {{ cancelButtonText }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          (click)="onClickButton()"
        >
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
